import React from 'react'
import {Link} from '@cred/react-link'
import PropTypes from 'prop-types'

const ExternalDisclosure = ({disclosure}) => <a target="blank" href={disclosure.url}>{disclosure.label}</a>

ExternalDisclosure.propTypes = {
  disclosure: PropTypes.object.isRequired,
  child: PropTypes.bool
}

export default ExternalDisclosure
